import {FC} from 'react';

import {DialogContent, Stack, Typography, Box} from '@mui/material';
import {t} from 'i18next';

import {useBasketCalculations} from 'hooks/useBasketCalculations';
import {PriceBreakdown} from 'types';
import {formatPriceWithCurrency} from 'utils/currency';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog} from './styles';
import {BasketDeliveryFee} from '../basket-header/BasketDeliveryFee';

export interface DeliveryFeeModalProps {
  open: boolean;
  onClose: () => void;
  priceBreakdown: PriceBreakdown[];
  showFreeDeliveryText: boolean;
}

export const DeliveryFeeModal: FC<DeliveryFeeModalProps> = (props) => {
  const {freeThreshold, defaultShippingFee, priceUnit} = useBasketCalculations();

  const freeDeliverySpend = formatPriceWithCurrency(freeThreshold, priceUnit);
  const sellers1p = props?.priceBreakdown.filter((item) => item.is3PSeller === false);
  const sellers3P = props.priceBreakdown.filter((item) => item.is3PSeller === true);
  return (
    <StyledDialog className="DeliveryFeeModel" open={props.open} onClose={props.onClose}>
      <BasketDialogTitle title={t('deliveryInfo.title')} onClose={props.onClose} />
      <DialogContent>
        <Stack spacing={2}>
          {sellers1p.map((pb) => (
            <Box key={pb.shopId}>
              <Box display="flex" justifyContent="space-between">
                <Typography>{t('makroPro')}</Typography>
                <BasketDeliveryFee
                  priceUnit={priceUnit}
                  currentShippingFee={pb.shippingFee}
                  defaultShippingFee={defaultShippingFee}
                />
              </Box>
              {props.showFreeDeliveryText && (
                <Typography color="grey.400" fontSize="0.9rem">
                  {t('deliveryInfo.getFreeDeliveryMakro', {
                    freeDeliverySpend
                  })}
                </Typography>
              )}
            </Box>
          ))}

          {sellers3P.map((pb) => (
            <Box key={pb.shopId} display="flex" justifyContent="space-between">
              <Typography>{pb.shopName}</Typography>
              <BasketDeliveryFee priceUnit={priceUnit} currentShippingFee={pb.shippingFee} />
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </StyledDialog>
  );
};

DeliveryFeeModal.displayName = 'DeliveryFeeModal';
